export default [
    {
        path: '/fila-vendas-leilao', component: () => import('./components/Page'), name: 'leilao.fila.vendas.page', children: [
            {path: '', component: () => import('./components/List'), name: 'leilao.fila.vendas'},
            {path: ':id', component: () => import('./components/Show'), name: 'leilao.fila.vendas.show'},
        ]
    }
]
